import React, { useState } from "react";
import { fetchClubConfig } from 'apollo-desktop/services';
import ReportsView from 'apollo-desktop';
import './style.css';
import { getProdFlag } from "../../utils/envVals";
import { getCookie } from "../../utils/utils";

export const ACTION_TYPE = {
    REPORT_ISSUE: 'REPORT_ISSUE',
    PUSH_FEEDBACK: 'PUSH_FEEDBACK',
    DEFAULT: 'DEFAULT',
    INSIGHT_IQ_ASSISTANT: 'INSIGHT_IQ_ASSISTANT'
};

function ApolloReactComponent(props: { actionType: keyof typeof ACTION_TYPE; userProfile: { id: string; displayName: string }; closeModal: (actionType: string) => void }) {
    const { userProfile } = props
    const [reportsConfig, setReportsConfig] = useState<any | null>(null);
    const [actionType, setActionType] = useState(ACTION_TYPE.DEFAULT);
    const isProduction = getProdFlag()

    const message = 'Actions on external app after closing the Modal';

    const getApolloConfig = () => {
        const authorization = getCookie('iam_auth_token') || undefined;
        return {
            club: '9930',
            appName: 'Vision',
            appVersion: '4.59.1',
            isProduction,
            userId: userProfile?.id || ' ',
            userName: userProfile ? userProfile.displayName : ' ',
            ping_token_flag: 'no',
            authorization,
            onModalClose: () => {
                console.log(message);
            }
        };
    };

    React.useEffect(() => {
        (async () => {
            try {
                const { data } = await fetchClubConfig(getApolloConfig());
                setActionType(ACTION_TYPE[props.actionType as keyof typeof ACTION_TYPE])
                console.log(data)
            } catch (e) {
                const failedLoading = 'Failed to fetch reports club config';
                console.error(failedLoading, e);
            }
        })();
    }, [props.actionType])

    React.useEffect(() => {
        if ([ACTION_TYPE.REPORT_ISSUE, ACTION_TYPE.PUSH_FEEDBACK].includes(props.actionType)) {
            const baseConfig = getApolloConfig();
            const allReportsConfig = {
                appName: baseConfig.appName,
                appVersion: baseConfig.appVersion,
                club: baseConfig.club,
                userId: userProfile?.id || ' ',
                userName: userProfile ? userProfile.displayName : ' ',
                isProduction: baseConfig.isProduction,
                ping_token_flag: 'no',
                authorization: baseConfig.authorization,
                onModalClose: () => {
                    setActionType(ACTION_TYPE.DEFAULT);
                    props.closeModal(ACTION_TYPE.DEFAULT)
                    console.log(message);
                }
            }
            setReportsConfig(allReportsConfig);
        }
    }, [props.actionType])

    return (
        <ReportsView config={reportsConfig} actionType={actionType} />
    )
}

export default ApolloReactComponent;